import React, { Component } from 'react';
import moment from 'moment-timezone';
import { Link } from 'react-router-dom';
import { translate } from 'react-i18next';
import { STATUS } from './SDeliveryContainer.js';

class SDelivery extends Component {

  getSDeliveryLink = (sdelivery) => {
    return {
      pathname: "/sdelivery/" + sdelivery.id,
      state: {
        sdelivery: JSON.stringify(sdelivery)
      }
    };
  }

  // commentario prueba

  renderService = (sdelivery, index) => {
    const date = moment(sdelivery.fecha_creado, 'YYYY-MM-DD HH:mm:ss');
    let status;
    const { t } = this.props;

    switch (sdelivery.status_id) {
      default:
      case STATUS.PENDING:
        status = t('dashboard.sdelivery.status_pending');
        break;
      case STATUS.APPROVED:
        status = t('dashboard.sdelivery.status_approved');
        break;
      case STATUS.REJECTED:
        status = t('dashboard.sdelivery.status_rejected');
        break;
      case STATUS.CANCELED:
        status = t('dashboard.sdelivery.status_canceled');
        break;
      case STATUS.FORCED:
        status = t('dashboard.sdelivery.status_forced');
        break;
    }

    return(
      <tr key={index}>
        <td>{sdelivery.centro}</td>
        <td>{date.format('DD-MM-YYYY')}</td>
        <td>{sdelivery.socio}</td>
        <td>{status}</td>
        <td>
          <center><Link to={this.getSDeliveryLink(sdelivery)}>
            <button
              className="btn btn-primary"
              type="button">
              {t('dashboard.sdelivery.btn_info')}
            </button>
          </Link></center>
        </td>
      </tr>
    );
  }

  render() {
    const sdeliveries_pendientes = this.props.sdeliveries_pendientes;
    const sdeliveries_actualizadas = this.props.sdeliveries_actualizadas;
    return(
      <div>
        {sdeliveries_pendientes && this.renderSDTable(sdeliveries_pendientes, 'pending')}
        {sdeliveries_actualizadas && this.renderSDTable(sdeliveries_actualizadas, 'history')}
      </div>
    );
  }

  renderSDTable = (sdeliveries, heading) => {
    const { t } = this.props;

    return(
      <div>
        <h4 className="page-header text-primary">
          <strong>{t('dashboard.sdelivery.heading_'+heading)}</strong>
        </h4>

        <div className="table-responsive">          
          <table className="table table-bordered">
            <thead>
              <tr>
                <th><center>{t('dashboard.sdelivery.col_center')}</center></th>
                <th><center>{t('dashboard.sdelivery.col_date')}</center></th>
                <th><center>{t('dashboard.sdelivery.col_client')}</center></th>
                <th><center>{t('dashboard.sdelivery.col_status')}</center></th>
                <th><center>{t('dashboard.sdelivery.col_view')}</center></th>
              </tr>
            </thead>
            <tbody>
              {sdeliveries.map(
                  (_, index) => this.renderService(sdeliveries[index], index)
              )}
            </tbody>
          </table>
        </div>

      </div>
    );

  }
}


export default translate('common')(SDelivery);



// WEBPACK FOOTER //
// ./src/dashboard/sdelivery/SDelivery.js